import { render } from "./TrackAndTraceList.vue?vue&type=template&id=bbe5e49c&scoped=true"
import script from "./TrackAndTraceList.vue?vue&type=script&lang=js"
export * from "./TrackAndTraceList.vue?vue&type=script&lang=js"

import "./TrackAndTraceList.vue?vue&type=style&index=0&id=bbe5e49c&scoped=true&lang=css"

import exportComponent from "C:\\project\\webtrackandtrace\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbe5e49c"]])

export default __exports__